import React from 'react';
import styled from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import { LineContent, BackgroundGradient, animationLine } from './commonStyles';

const LeadsData = ({ device, onSharedDesempeno }) => {
  return (
    <Container className={`skeleton-leadsData-${device}`}>
      {!onSharedDesempeno && (
        <DesempenoTag className={`skeleton-desempeno-tag-${device}`}>
          {device === 'mobile' && <LineContent width='150px' />}
        </DesempenoTag>
      )}
      <LeadsDataArea className={`skeleton-desempeno-dataArea-${device}`}>
        {device === 'desktop' && (
          <>
            <LeadsDataItem>
              <div />
              <div>
                <LineContent width='100px' marginTop='6px' marginBottom='22px' />
                <LineContent width='100px' marginBottom='16px' />
                <LineContent width='136px' />
              </div>
            </LeadsDataItem>
            <LeadsDataItem>
              <div />
              <div>
                <LineContent width='119px' marginTop='6px' marginBottom='22px' />
                <LineContent width='100px' marginBottom='16px' />
                <LineContent width='135px' />
              </div>
            </LeadsDataItem>
            <LeadsDataItem>
              <div />
              <div>
                <LineContent width='119px' marginTop='6px' marginBottom='22px' />
                <LineContent width='100px' marginBottom='16px' />
                <LineContent width='133px' />
              </div>
            </LeadsDataItem>
          </>
        )}
        {device === 'tablet' && (
          <>
            <LeadsDataItem className='skeleton-leadsData-item-tablet'>
              <div />
              <div>
                <LineContent width='100px' marginBottom='13px' />
                <LineContent width='100px' height='19px' marginBottom='19px' />
                <LineContent width='130px' />
              </div>
            </LeadsDataItem>
            <LeadsDataItem className='skeleton-leadsData-item-tablet'>
              <div />
              <div>
                <LineContent width='100px' marginBottom='13px' />
                <LineContent width='100px' height='19px' marginBottom='19px' />
                <LineContent width='130px' />
              </div>
            </LeadsDataItem>
            <LeadsDataItem className='skeleton-leadsData-item-tablet'>
              <div />
              <div>
                <LineContent width='100px' marginBottom='13px' />
                <LineContent width='100px' height='19px' marginBottom='19px' />
                <LineContent width='130px' />
              </div>
            </LeadsDataItem>
          </>
        )}
        {device === 'mobile' && (
          <>
            <LeadsDataItem className='skeleton-leadsData-item-mobile'>
              <div />
              <div>
                <LineContent width='150px' marginBottom='16px' />
                <LineContent width='70px' />
              </div>
            </LeadsDataItem>
            <LeadsDataItem className='skeleton-leadsData-item-mobile'>
              <div />
              <div>
                <LineContent width='150px' marginBottom='16px' />
                <LineContent width='70px' />
              </div>
            </LeadsDataItem>
            <LeadsDataItem className='skeleton-leadsData-item-mobile'>
              <div />
              <div>
                <LineContent width='150px' marginBottom='16px' />
                <LineContent width='70px' />
              </div>
            </LeadsDataItem>
          </>
        )}
      </LeadsDataArea>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  &.skeleton-leadsData-desktop {
    margin-bottom: 42px;
  }
  &.skeleton-leadsData-tablet {
    margin-bottom: 40px;
  }
  &.skeleton-leadsData-mobile {
    :after {
      content: '';
      width: 100%;
      border-bottom: 1px solid ${select('middleGray')};
      margin-top: 31px;
      margin-bottom: 33px;
      display: block;
    }
  }
`;

const DesempenoTag = styled.div`
  width: 100%;
  height: 49px;
  border-radius: 8px;
  background-color: ${select('grayMedium')};
  margin-bottom: 16px;
  &.skeleton-desempeno-tag-mobile {
    background-color: white;
    border: 1px solid ${select('grayMedium')};
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: -6px 0px 34px 7px rgba(196, 196, 196, 0.12);
    margin-bottom: 7px;
  }
`;

const LeadsDataArea = styled.div`
  width: 100%;
  height: 156px;
  display: flex;
  justify-content: space-around;
  border-radius: 8px;
  border: 1px solid ${select('grayMedium')};
  padding: ${({ device }) => (device === 'desktop' ? '24px 37px' : '32px 27px')};
  &.skeleton-desempeno-dataArea-mobile {
    padding: 26px 12px;
    height: 293px;
    box-shadow: -6px 0px 34px 7px rgba(196, 196, 196, 0.12);
    flex-direction: column;
  }
`;

const LeadsDataItem = styled.div`
  display: flex;
  :last-of-type {
    margin-right: 0;
  }
  > div {
    :first-of-type {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      ${BackgroundGradient};
      ${animationLine};
      margin-right: 11px;
    }
  }
  &.skeleton-leadsData-item-tablet {
    :after {
      content: '';
      height: 95px;
      border-right: 1px solid ${select('middleGray')};
      margin-left: 24px;
    }
    :last-of-type {
      :after {
        display: none;
      }
    }
    > div {
      :first-of-type {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        ${BackgroundGradient};
        ${animationLine};
        margin-right: 16px;
      }
    }
  }
  &.skeleton-leadsData-item-mobile {
    > div {
      :first-of-type {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        ${BackgroundGradient};
        ${animationLine};
        margin-right: 26px;
      }
    }
  }
`;

export default LeadsData;
